import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsConnect from "./sections/LetsConnect";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsConnect />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}